
<template>
    <div class="product-department-container">
        <ThatsTable title="Product Departments" ref="table" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns"></ThatsTable>
        <ProductDepartmentForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></ProductDepartmentForm>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ProductDepartmentForm from './ProductDepartmentForm'
import ThatsTable from '../../components/thats/Table'
export default {
    data(){
        return {
            endpoint : 'product-departments'
        }
    },
    components: {
        ProductDepartmentForm,
        ThatsTable
    },

    methods: {
        ...mapActions('ProductDepartmentModule', ['deleteRecord']),
        ...mapMutations('ProductDepartmentModule',[ 'setFormRecord', 'setFormStatusUpdate']),

        formDelete(record){
            this.DispatchDelete([record.row]);
        },
        DispatchDelete(items){
            this.deleteRecord(items).then(() => this.refreshTable());
        },

        OpenUpdateModal(obj){
            this.setFormStatusUpdate()
            this.setFormRecord(obj)
            this.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        }
    },
    computed: {
        ...mapGetters('ProductDepartmentModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
    },
}
</script>
<style scoped>
.product-department-container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>
